var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"14","height":"12","viewBox":"0 0 14 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1 6.83358L4.74731 10.1669L12.2131 1.35742","stroke":"#0CBA4A","stroke-width":"2.1"}})])}
var staticRenderFns = []

export { render, staticRenderFns }